import React from 'react';

// Styles & Assets
import styles from './GenerateRoute.module.css';

// Hooks
import { useState } from 'react';

// Components
import PatientsSelector from '../PatientsSelector/PatientsSelector';
import Modal from '../../UI/Modal/Modal';
import DialogRouteStart from './../DialogRouteStart/DialogRouteStart';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';

// GenerateRoute: Lets the user create a route, naming it and adding patients.
const GenerateRoute: React.FC = () => {

    const { t } = useTranslation();

    const [nameRoute, setNameRoute] = useState<string>('');
    const [patientsSelected, setPatientsSelected] = useState<{ id: number, name: string }[]>([]);
    const [showRouteStartDialog, setShowRouteStartDialog] = useState<boolean>(false);

    const handleInputChange = (evt: React.FormEvent) => 
        setNameRoute((evt.target as HTMLInputElement).value);

    const getRoute = () => {
        const patientsIDs = patientsSelected.map(patient => {
            return patient.id;
        });
        return { name: nameRoute, patients: patientsIDs };
    };

    const handleClickSetRoute = () => setShowRouteStartDialog(true);

    const isDisabled = nameRoute.trim() === '' || patientsSelected.length === 0;

    return (
        <>
            <div className={styles.generateRouteContainer}>
                <div className={styles.routeNameContainer}>
                    <p className={styles.routeSubtitles}>{t('_1_enter_route')}</p>
                    <input onChange={handleInputChange} type={'text'} className={styles.inputName} />
                </div>
                <div className={styles.selectPatientsContainer}>
                    <p className={styles.routeSubtitles}>{t('_2_select_patients')}</p>
                    <PatientsSelector
                        patientsSelected={patientsSelected}
                        setPatientsSelected={setPatientsSelected}
                    />
                </div>
                <div className={styles.buttonsContainer}>
                    <Link to={'/home/routes/routes_map_patients'} className={`${styles.cancel} anchorButton`}>{t('cancel')}</Link>
                    <button onClick={handleClickSetRoute} disabled={isDisabled} className={`button ${styles.confirm} ${isDisabled && 'blockedButton'}`}>{t('set_route')}</button>
                </div>
            </div>
            <Modal show={showRouteStartDialog} setShowModal={setShowRouteStartDialog}>
                <DialogRouteStart getRoute={getRoute} />
            </Modal>
        </>
    );
};

export default GenerateRoute;